import { render, staticRenderFns } from "./PublicationCardAlert.vue?vue&type=template&id=5c8f3346"
import script from "./PublicationCardAlert.vue?vue&type=script&lang=js"
export * from "./PublicationCardAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports